import { create } from "zustand";
import { createJSONStorage, persist, subscribeWithSelector } from "zustand/middleware";

type EndpointState = {
  apiEndpoint: string;
};

type EndpointStore = EndpointState;

const initialState: EndpointState = {
  apiEndpoint: "",
};

const useEndpointStore = create(
  subscribeWithSelector(
    persist<EndpointStore>(
      (_set) => ({
        ...initialState,
      }),
      {
        name: "ENDPOINT",
        storage: createJSONStorage(() => localStorage),
        onRehydrateStorage: (state) => {
          const endpoint = localStorage.getItem("ENDPOINT");

          if (endpoint) {
            const json = JSON.parse(endpoint).state as EndpointState;

            state.apiEndpoint = json.apiEndpoint;
          }
        },
      },
    ),
  ),
);

export default useEndpointStore;
